module.exports = __webpack_public_path__ + "static/media/tietoa-logo.51e71e41.svg";